import * as classNames from "classnames";

export const inputClasses = (error: string) => classNames("form-control", { "input-validation-error": error !== undefined });
